import { Injectable } from '@angular/core';
import { ValidationProvider } from '@services/helpers/validation.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { TimeServiceProvider } from '@services/helpers/time-service/time.service';
import { TimeConverterProvider } from '@services/helpers/time-converter';

@Injectable()
export class ExtraShootServiceProvider {
	extraShootType = 'EXTRA_SHOOT';

	constructor(
		private validationService: ValidationProvider,
		private messageService: MessageService,
		private timeService: TimeServiceProvider,
		private timeConverter: TimeConverterProvider
	) {}

	private isItemChosen(item): boolean {
		const itemChosen = item && item.id;
		return !!itemChosen;
	}

	private createJobSearchObject(appointment) {
		const { jobId, jobName } = appointment;
		return {
			id: jobId,
			name: jobName
		};
	}

	private prepareExtraShootTask(extraShoot) {
		extraShoot.calendarEvent = {
			id: extraShoot.calendarEvent ? extraShoot.calendarEvent.id : null,
			name: extraShoot.name,
			number: extraShoot.number,
			startDate: extraShoot.startDate,
			endDate: extraShoot.endDate,
			startTime: extraShoot.startTime,
			endTime: extraShoot.endTime,
			location: extraShoot.location
		};

		return extraShoot;
	}

	prepareExtraShootToSave(
		extraShoot,
		isJobView: boolean,
		location: string,
		extraShootLabel: string
	) {
		let dataToSave = this.validateExtraShoot(
			extraShoot,
			isJobView,
			extraShootLabel
		);

		if (!dataToSave) {
			return false;
		}

		dataToSave.location = location;
		dataToSave.calendarEventType = this.extraShootType;

		const { jobSearch } = extraShoot;
		if (jobSearch) {
			dataToSave.jobId = jobSearch.id;
			delete dataToSave.addToJob;
			delete dataToSave.jobSearch;
		}

		if (isJobView) {
			dataToSave = this.prepareExtraShootTask(dataToSave);
		}

		return dataToSave;
	}

	prepareExtraShootToShow(event) {
		const extraShoot = Object.assign({}, event);

		const { jobId, startTime } = extraShoot;

		extraShoot.allday = !startTime;

		if (jobId) {
			extraShoot.jobSearch = this.createJobSearchObject(extraShoot);
			extraShoot.addToJob = true;
		}

		return extraShoot;
	}

	private validateExtraShoot(
		extraShoot,
		isJobView: boolean,
		extraShootLabel: string
	) {
		let dateStart, dateEnd, timeStart, timeEnd;
		const validExtraShoot = Object.assign({}, extraShoot);

		if (this.validationService.isStringEmpty(validExtraShoot.name)) {
			this.messageService.showToaster('e_3', 'general', 'name');
			return false;
		}

		if (!isJobView && !this.isItemChosen(validExtraShoot.jobSearch)) {
			this.messageService.showToaster('e_0', 'extrashoot', extraShootLabel);
			return false;
		}

		if (!validExtraShoot.startDate || !validExtraShoot.endDate) {
			this.messageService.showToaster('e_1', 'appointment');
			return false;
		}

		dateStart = this.timeService.getDateInFormat(
			validExtraShoot.startDate,
			'date'
		);
		dateEnd = this.timeService.getDateInFormat(validExtraShoot.endDate, 'date');

		const isCorrectDate = this.timeService.compareDates(dateEnd, dateStart);

		if (isCorrectDate) {
			this.messageService.showToaster('e_2', 'appointment');
			return false;
		}

		if (!validExtraShoot.allday) {
			const isStartIn24Format = this.timeService.isIn24Format(
				validExtraShoot.startTime
			);
			const isEndIn24Format = this.timeService.isIn24Format(
				validExtraShoot.endTime
			);
			timeStart = isStartIn24Format
				? validExtraShoot.startTime
				: this.timeConverter.convert12to24(validExtraShoot.startTime);
			timeEnd = isEndIn24Format
				? validExtraShoot.endTime
				: this.timeConverter.convert12to24(validExtraShoot.endTime);

			if (!timeStart || !timeEnd) {
				this.messageService.showToaster('e_0', 'appointment');
				return false;
			}

			if (dateStart === dateEnd) {
				const isCorrectTime = this.timeService.compareTimes(timeStart, timeEnd);

				if (!isCorrectTime) {
					this.messageService.showToaster('e_2', 'appointment');
					return false;
				}
			}
		}

		validExtraShoot.startDate = dateStart;
		validExtraShoot.endDate = dateEnd;
		validExtraShoot.startTime = timeStart;
		validExtraShoot.endTime = timeEnd;

		return validExtraShoot;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/services/tasks/extra-shoot.service.ts